import Vue from 'vue'
import { get } from 'lodash-es'

import CONSTANTS from './constants'
import { ROOT_MUTATION_TYPES, SOURCE_DATA_MUTATION_TYPES, MUTATION_TYPES } from './mutation-types'

import { initialState } from './state'

export default {
  ...Object.keys(ROOT_MUTATION_TYPES).reduce(
    (acc, key) => ({
      ...acc,
      [key]: (state, data) => {
        const stateKey = CONSTANTS[key.replace('SET_', '')]

        Vue.set(state, stateKey, data)
      },
    }),
    {},
  ),
  ...Object.keys(SOURCE_DATA_MUTATION_TYPES).reduce(
    (acc, key) => ({
      ...acc,
      [key]: (state, data) => {
        const stateKey = CONSTANTS[key.replace('SET_', '')]

        Vue.set(state[CONSTANTS.SOURCE_DATA], stateKey, data)
      },
    }),
    {},
  ),
  [MUTATION_TYPES.ADD_FORM_ERROR]: (state, data) => {
    state[CONSTANTS.FORM_ERRORS].push(data)
  },
  [MUTATION_TYPES.RESET_FORM_ERRORS]: state => {
    Vue.set(state, CONSTANTS.FORM_ERRORS, [])
  },
  [MUTATION_TYPES.UPDATE_FORM_DATA]: (state, data) => {
    Vue.set(state, CONSTANTS.FORM_DATA, {
      ...get(state, CONSTANTS.FORM_DATA, {}),
      ...data,
    })
  },
  [MUTATION_TYPES.RESET_FORM_DATA]: state => {
    Vue.set(state, CONSTANTS.FORM_DATA, initialState.FORM_DATA)
  },
  [MUTATION_TYPES.ADD_SKIPPED_STEP]: (state, step) => {
    state[CONSTANTS.SKIP_STEPS] = [...state[CONSTANTS.SKIP_STEPS], step]
  },
  [MUTATION_TYPES.REMOVE_SKIPPED_STEP]: (state, step) => {
    state[CONSTANTS.SKIP_STEPS] = state[CONSTANTS.SKIP_STEPS].filter(val => val !== step)
  },

  [MUTATION_TYPES.SET_BIKE_COMPONENT_DATA]: (state, data) => {
    state[CONSTANTS.BIKE_COMPONENT_DATA] = data
  },
  [MUTATION_TYPES.SET_COMPONENT_SELECTIONS]: (state, selections) => {
    state[CONSTANTS.COMPLAINT_FORM_COMPONENT.BIKE_SELECTIONS] = selections
  },
  [MUTATION_TYPES.SET_CHECKBOX_SELECTIONS]: (state, selections) => {
    state[CONSTANTS.COMPLAINT_FORM_COMPONENT.CHECKBOX_SELECTIONS].push(selections)
  },
  [MUTATION_TYPES.REMOVE_CHECKBOX_SELECTION]: (state, sparePart) => {
    state[CONSTANTS.COMPLAINT_FORM_COMPONENT.CHECKBOX_SELECTIONS].forEach((selectedItem, index) => {
      if (sparePart.id === selectedItem.id) {
        state[CONSTANTS.COMPLAINT_FORM_COMPONENT.CHECKBOX_SELECTIONS].splice(index, 1)
      }
    })
  },
  [MUTATION_TYPES.REMOVE_ALL_CHECKBOX_SELECTIONS]: state => {
    state[CONSTANTS.COMPLAINT_FORM_COMPONENT.CHECKBOX_SELECTIONS] = []
    state[CONSTANTS.COMPLAINT_FORM_COMPONENT.BIKE_SELECTIONS] = []
  },
}
